const rankSubName = ['st', 'nd', 'rd']

const formatRank = data => {
  const dataString = `${data}`
  const lastChar = parseInt(dataString[dataString.length - 1])
  const secondLastChar =
    dataString[dataString.length - 2] &&
    parseInt(dataString[dataString.length - 2])
  return `${data}${
    secondLastChar === 1 ? 'th' : rankSubName[lastChar - 1] || 'th'
  }`
}

export { formatRank }
